core.service('core.objectHelper', ['stringUtils', '$translate',
    function(stringUtils, $translate) {

        this.createObject = function(targetClass, obj) {
            return this.translateObject(obj, targetClass);
        };

        this.o = function(targetClass, obj) {
            return this.createObject(targetClass, obj);
        };

        this.cloneObject = function(obj) {
            return this.translateObject(obj, obj.constructor);
        };

        this.translateObject = function(obj, targetClass) {
            // fixme
            if(targetClass === DictionaryElementVO) {
                if($translate.use() === 'de_DE') {
                    if(obj.englishValue) {
                        obj.value = obj.englishValue
                    }
                    if(obj.englishDescription) {
                        obj.description = obj.englishDescription
                    }
                }
            }
            var result = new targetClass();
            for (var property in obj) {
                if (result.hasOwnProperty(property) || (result._getMapping && _.isFunction(result._getMapping) && result._getMapping(property))) {
                    var targetProperty = null;

                    if (result._getMapping && _.isFunction(result._getMapping)) {
                        targetProperty = result._getMapping(property);
                    }

                    if (!targetProperty) {
                        targetProperty = property;
                    }

                    if (_.isFunction(obj[property])) {
                        result[targetProperty] = obj[property];
                    }
                    if (_.isArray(obj[property])) {
                        var targetItemClass = result._getType(targetProperty);
                        if (_.isUndefined(targetItemClass)) {
                            result[targetProperty] = obj[property];
                        }
                        else {
                            // check for dates, if it's a date, we'll cover that in a separate function
                            var tempItemObject = new targetItemClass();
                            if (!_.isDate(tempItemObject)) {
                                result[targetProperty] = this.translateArray(obj[property], targetItemClass);
                            }
                            else {
                                result[targetProperty] = obj[property];
                            }
                        }
                    }
                    else if (_.isObject(obj[property])) {
                        var targetClassForObject = result._getType(targetProperty);
                        if ( _.isUndefined(targetClassForObject)) {
                            result[targetProperty] = obj[property];
                        }
                        else {
                            // check for dates, if it's a date, we'll cover that in a separate function
                            var tempObject = new targetClassForObject();
                            if (!_.isDate(tempObject)) {
                                result[targetProperty] = this.translateObject(obj[property], targetClassForObject);
                            }
                            else {
                                result[targetProperty] = obj[property];
                            }
                        }
                    }
                    else {
                        result[targetProperty] = obj[property];
                    }
                }
            }
            return result;
        };

        this.stripObject = function(obj) {
            var result = {};
            for (var property in obj) {
                if (_.isFunction(obj[property]) && (property == '_getType' || property == '_getMapping')) {
                    delete result[property];
                }
                else if (_.isArray(obj[property])) {
                    result[property] = this.stripArray(obj[property]);
                }
                else if (_.isObject(obj[property])) {
                    result[property] = this.stripObject(obj[property]);
                }
                else {
                    result[property] = obj[property];
                }
            }
            return result;
        };

        this.translateArray = function(arr, targetItemClass) {
            var result = angular.copy(arr);
            var arrayLength = result.length;
            for (var i = 0; i < arrayLength; i++) {
                if (_.isObject(result[i]) && !_.isDate(result[i])) {
                    result[i] = this.translateObject(result[i], targetItemClass);
                }
            }
            return result;
        };

        this.stripArray = function(arr) {
            var result = angular.copy(arr);
            var arrayLength = result.length;
            for (var i = 0; i < arrayLength; i++) {
                if (_.isObject(result[i]) && !_.isDate(result[i])) {
                    result[i] = this.stripObject(result[i]);
                }
            }
            return result;
        };

        this.convertDatesToTimes = function(src, treatThisSourceOrArrayItemsAsDate, forcedProperties) {
            if (_.isDate(src) || treatThisSourceOrArrayItemsAsDate) {
                return src.getTime();
            }
            else if (_.isArray(src)) {
                var resultForArray = angular.copy(src);
                var arrayLengthForArray = resultForArray.length;

                for (var i = 0; i < arrayLengthForArray; i++) {
                    if (_.isObject(resultForArray[i]) && !_.isDate(resultForArray[i]) && !treatThisSourceOrArrayItemsAsDate) {
                        resultForArray[i] = this.convertDatesToTimes(resultForArray[i]);
                    }
                    else if (_.isObject(resultForArray[i]) && (_.isDate(resultForArray[i]) || treatThisSourceOrArrayItemsAsDate)) {
                        resultForArray[i] = resultForArray[i].getTime();
                    }
                }

                return resultForArray;
            }
            else if (_.isObject(src)) {
                var resultForObject = new src.constructor();

                for (var property in src) {
                    if (forcedProperties && _.contains(forcedProperties, property)) {
                        resultForObject[property] = src[property].getTime();
                    }
                    else if (_.isNumber(src[property])) {
                        var targetClassForNumber = resultForObject._getType(property);
                        var tempObjectForNumber;
                        if (_.isUndefined(targetClassForNumber)) {
                            tempObjectForNumber = null;
                        }
                        else {
                            tempObjectForNumber = new targetClassForNumber();
                        }

                        if (_.isDate(tempObjectForNumber)) {
                            resultForObject[property] = new Date(src[property]).getTime();
                        }
                        else {
                            resultForObject[property] = src[property];
                        }
                    }
                    else if (_.isDate(src[property])) {
                        var targetClassForDate = resultForObject._getType(property);
                        var tempObjectForDate;
                        if (_.isUndefined(targetClassForDate)) {
                            tempObjectForDate = null;
                        }
                        else {
                            tempObjectForDate = new targetClassForDate();
                        }

                        if (_.isDate(tempObjectForDate)) {
                            resultForObject[property] = src[property].getTime();
                        }
                        else {
                            resultForObject[property] = src[property];
                        }
                    }
                    else if (_.isFunction(src[property])) {
                        resultForObject[property] = src[property];
                    }
                    else if (_.isArray(src[property])) {
                        resultForObject[property] = [];
                        var arrayLengthForArrayInObject = (src[property]).length;

                        var targetClassForArrayInObject = resultForObject._getType(property);
                        var tempObjectForArrayInObject;
                        if (_.isUndefined(targetClassForArrayInObject)) {
                            tempObjectForArrayInObject = null;
                        }
                        else {
                            tempObjectForArrayInObject = new targetClassForArrayInObject();
                        }

                        for (var j = 0; j < arrayLengthForArrayInObject; j++) {
                            (resultForObject[property])[j] = this.convertDatesToTimes((src[property])[j], _.isDate(tempObjectForArrayInObject));
                        }
                    }
                    else if (_.isObject(src[property])) {
                        resultForObject[property] = this.convertDatesToTimes(src[property]);
                    }
                    else {
                        resultForObject[property] = src[property];
                    }
                }
                return resultForObject;
            }
            else {
                return src;
            }
        };

        this.convertTimesToDates = function(src, treatThisSourceOrArrayItemsAsDate, forcedProperties) {
            if (_.isNumber(src)) {
                if (treatThisSourceOrArrayItemsAsDate) {
                    return new Date(src);
                }
                else {
                    return src;
                }
            }
            else if (_.isArray(src)) {
                var resultForArray = angular.copy(src);
                var arrayLengthForArray = resultForArray.length;

                for (var i = 0; i < arrayLengthForArray; i++) {
                    if (_.isObject(resultForArray[i]) && !treatThisSourceOrArrayItemsAsDate) {
                        resultForArray[i] = this.convertTimesToDates(resultForArray[i]);
                    }
                    else if (_.isNumber(resultForArray[i]) && treatThisSourceOrArrayItemsAsDate) {
                        resultForArray[i] = new Date(resultForArray[i]);
                    }
                }

                return resultForArray;
            }
            else if (_.isObject(src)) {
                var resultForObject = new src.constructor();

                for (var property in src) {
                    if (forcedProperties && _.contains(forcedProperties, property)) {
                        resultForObject[property] = new Date(src[property]);
                    }
                    else if (_.isNumber(src[property])) {
                        var targetClassForNumber = resultForObject._getType(property);
                        var tempObjectForNumber;
                        if (_.isUndefined(targetClassForNumber)) {
                            tempObjectForNumber = null;
                        }
                        else {
                            tempObjectForNumber = new targetClassForNumber();
                        }

                        if (_.isDate(tempObjectForNumber)) {
                            resultForObject[property] = new Date(src[property]);
                        }
                        else {
                            resultForObject[property] = src[property];
                        }
                    }
                    else if (_.isDate(src[property])) {
                        resultForObject[property] = src[property];
                    }
                    else if (_.isFunction(src[property])) {
                        resultForObject[property] = src[property];
                    }
                    else if (_.isArray(src[property])) {
                        resultForObject[property] = [];
                        var arrayLengthForArrayInObject = (src[property]).length;

                        var targetClassForArrayInObject = resultForObject._getType(property);
                        var tempObjectForArrayInObject;
                        if (_.isUndefined(targetClassForArrayInObject)) {
                            tempObjectForArrayInObject = null;
                        }
                        else {
                            tempObjectForArrayInObject = new targetClassForArrayInObject();
                        }

                        for (var j = 0; j < arrayLengthForArrayInObject; j++) {
                            (resultForObject[property])[j] = this.convertTimesToDates((src[property])[j], _.isDate(tempObjectForArrayInObject));
                        }
                    }
                    else if (_.isObject(src[property])) {
                        resultForObject[property] = this.convertTimesToDates(src[property]);
                    }
                    else {
                        resultForObject[property] = src[property];
                    }
                }
                return resultForObject;
            }
            else {
                return src;
            }
        };


        this.convertDatesToStrings = function(src, treatThisSourceOrArrayItemsAsDate, forcedProperties) {
            if (_.isDate(src) || treatThisSourceOrArrayItemsAsDate) {
                return stringUtils.formatCustomDate(src);
            }
            else if (_.isArray(src)) {
                var resultForArray = angular.copy(src);
                var arrayLengthForArray = resultForArray.length;

                for (var i = 0; i < arrayLengthForArray; i++) {
                    if (_.isObject(resultForArray[i]) && !_.isDate(resultForArray[i]) && !treatThisSourceOrArrayItemsAsDate) {
                        resultForArray[i] = this.convertDatesToStrings(resultForArray[i]);
                    }
                    else if (_.isObject(resultForArray[i]) && (_.isDate(resultForArray[i]) || treatThisSourceOrArrayItemsAsDate)) {
                        resultForArray[i] = stringUtils.formatCustomDate(resultForArray[i]);
                    }
                }

                return resultForArray;
            }
            else if (_.isObject(src)) {
                var resultForObject = new src.constructor();

                for (var property in src) {
                    if (forcedProperties && _.contains(forcedProperties, property)) {
                        resultForObject[property] = stringUtils.formatCustomDate(src[property]);
                    }
                    else if (_.isNumber(src[property])) {
                        var targetClassForNumber = resultForObject._getType(property);
                        var tempObjectForNumber;
                        if (_.isUndefined(targetClassForNumber)) {
                            tempObjectForNumber = null;
                        }
                        else {
                            tempObjectForNumber = new targetClassForNumber();
                        }

                        if (_.isDate(tempObjectForNumber)) {
                            resultForObject[property] = stringUtils.formatCustomDate(new Date(src[property]));
                        }
                        else {
                            resultForObject[property] = src[property];
                        }
                    }
                    else if (_.isDate(src[property])) {
                        var targetClassForDate = resultForObject._getType(property);
                        var tempObjectForDate;
                        if (_.isUndefined(targetClassForDate)) {
                            tempObjectForDate = null;
                        }
                        else {
                            tempObjectForDate = new targetClassForDate();
                        }

                        if (_.isDate(tempObjectForDate)) {
                            resultForObject[property] = stringUtils.formatCustomDate(src[property]);
                        }
                        else {
                            resultForObject[property] = src[property];
                        }
                    }
                    else if (_.isFunction(src[property])) {
                        resultForObject[property] = src[property];
                    }
                    else if (_.isArray(src[property])) {
                        resultForObject[property] = [];
                        var arrayLengthForArrayInObject = (src[property]).length;

                        var targetClassForArrayInObject = resultForObject._getType(property);
                        var tempObjectForArrayInObject;
                        if (_.isUndefined(targetClassForArrayInObject)) {
                            tempObjectForArrayInObject = null;
                        }
                        else {
                            tempObjectForArrayInObject = new targetClassForArrayInObject();
                        }

                        for (var j = 0; j < arrayLengthForArrayInObject; j++) {
                            (resultForObject[property])[j] = this.convertDatesToStrings((src[property])[j], _.isDate(tempObjectForArrayInObject));
                        }
                    }
                    else if (_.isObject(src[property])) {
                        resultForObject[property] = this.convertDatesToStrings(src[property]);
                    }
                    else {
                        resultForObject[property] = src[property];
                    }
                }
                return resultForObject;
            }
            else {
                return src;
            }
        };

        this.convertStringsToDates = function(src, treatThisSourceOrArrayItemsAsDate, forcedProperties) {
            if (_.isString(src)) {
                if (treatThisSourceOrArrayItemsAsDate) {
                    return new Date(src);
                }
                else {
                    return src;
                }
            }
            else if (_.isArray(src)) {
                var resultForArray = angular.copy(src);
                var arrayLengthForArray = resultForArray.length;

                for (var i = 0; i < arrayLengthForArray; i++) {
                    if (_.isObject(resultForArray[i]) && !treatThisSourceOrArrayItemsAsDate) {
                        resultForArray[i] = this.convertStringsToDates(resultForArray[i]);
                    }
                    else if (_.isString(resultForArray[i]) && treatThisSourceOrArrayItemsAsDate) {
                        resultForArray[i] = new Date(resultForArray[i]);
                    }
                }

                return resultForArray;
            }
            else if (_.isObject(src)) {
                var resultForObject = new src.constructor();

                for (var property in src) {
                    if (forcedProperties && _.contains(forcedProperties, property)) {
                        resultForObject[property] = new Date(src[property]);
                    }
                    else if (_.isString(src[property])) {
                        var targetClassForString = resultForObject._getType(property);
                        var tempObjectForString;
                        if (_.isUndefined(targetClassForString)) {
                            tempObjectForString = null;
                        }
                        else {
                            tempObjectForString = new targetClassForString();
                        }

                        if (_.isDate(tempObjectForString)) {
                            resultForObject[property] = new Date(src[property]);
                        }
                        else {
                            resultForObject[property] = src[property];
                        }
                    }
                    else if (_.isDate(src[property])) {
                        resultForObject[property] = src[property];
                    }
                    else if (_.isFunction(src[property])) {
                        resultForObject[property] = src[property];
                    }
                    else if (_.isArray(src[property])) {
                        resultForObject[property] = [];
                        var arrayLengthForArrayInObject = (src[property]).length;

                        var targetClassForArrayInObject = resultForObject._getType(property);
                        var tempObjectForArrayInObject;
                        if (_.isUndefined(targetClassForArrayInObject)) {
                            tempObjectForArrayInObject = null;
                        }
                        else {
                            tempObjectForArrayInObject = new targetClassForArrayInObject();
                        }

                        for (var j = 0; j < arrayLengthForArrayInObject; j++) {
                            (resultForObject[property])[j] = this.convertStringsToDates((src[property])[j], _.isDate(tempObjectForArrayInObject));
                        }
                    }
                    else if (_.isObject(src[property])) {
                        resultForObject[property] = this.convertStringsToDates(src[property]);
                    }
                    else {
                        resultForObject[property] = src[property];
                    }
                }
                return resultForObject;
            }
            else {
                return src;
            }
        };
    }
]);